export const EMAIL_CONFIRMATION = 'Email confirmation';
export const INVALID_PHONE_LINE_TYPE = 'Please Enter a Unique Mobile Phone Number';
export const OTHER_HOME_IMPROVEMENT_CAPTION = 'Please Specify Home Improvement Type';
export const LOAN_TYPE_CAPTION =
  'Select joint application if you are using income from a spouse, domestic partner or other individual who lives at the same property.';
